'use strict';

import template from './casosPCD.html'
import controller from './casosPCD.controller'

const CasosPCDComponent = {
  controller,
  template
}

export default CasosPCDComponent



// WEBPACK FOOTER //
// ./src/app/components/soporte/casosPCD/casosPCD.component.js